import { nothing as i } from "../lit-html.js"; /**
                                               * @license
                                               * Copyright 2018 Google LLC
                                               * SPDX-License-Identifier: BSD-3-Clause
                                               */
var t = function t(o) {
  return o !== null && o !== void 0 ? o : i;
};
export { t as ifDefined };